import { warRoomClient } from './warRoomClient'
import type {
  Session,
  SessionConfig,
  PaginatedResponse,
  SingleResponse,
} from '../types/session.types'

export const sessionService = {
  /**
   * List sessions for workspace (paginated).
   */
  list: (params: {
    status?: string
    page?: number
    per_page?: number
  } = {}): Promise<PaginatedResponse<Session>> => {
    const searchParams = new URLSearchParams()
    if (params.status)   searchParams.set('status', params.status)
    if (params.page)     searchParams.set('page', String(params.page))
    if (params.per_page) searchParams.set('per_page', String(params.per_page))
    return warRoomClient.get('sessions', { searchParams }).json()
  },

  /**
   * Get single session by ID.
   */
  get: (sessionId: string): Promise<SingleResponse<Session>> =>
    warRoomClient.get(`sessions/${sessionId}`).json(),

  /**
   * Create new Go-Live session.
   */
  create: (payload: {
    name: string
    description?: string
    system_name: string
    environment: string
    planned_start: string   // ISO8601
    planned_end: string
    rollback_plan?: string
    notes?: string
    tags?: string[]
    config?: Partial<SessionConfig>
  }): Promise<SingleResponse<Session>> =>
    warRoomClient.post('sessions', { json: payload }).json(),

  /**
   * Start a session (draft → in_progress).
   */
  start: (sessionId: string): Promise<SingleResponse<Session>> =>
    warRoomClient.post(`sessions/${sessionId}/start`).json(),

  /**
   * Pause a running session.
   */
  pause: (sessionId: string): Promise<SingleResponse<Session>> =>
    warRoomClient.post(`sessions/${sessionId}/pause`).json(),

  /**
   * Resume a paused session.
   */
  resume: (sessionId: string): Promise<SingleResponse<Session>> =>
    warRoomClient.post(`sessions/${sessionId}/resume`).json(),

  /**
   * Complete a session.
   */
  complete: (sessionId: string): Promise<SingleResponse<Session>> =>
    warRoomClient.post(`sessions/${sessionId}/complete`).json(),

  /**
   * Transition to ready (marks session as ready for go-live).
   */
  markReady: (sessionId: string): Promise<SingleResponse<Session>> =>
    warRoomClient.post(`sessions/${sessionId}/ready`).json(),
}
